import axios from "axios";
import Cookies from "js-cookie";
import API_BASE_URL from "./apiConfig";

export async function submitOrder(forms, language) {
  // Generate a temp_id (order id)
  const temp_id_list = [];

  for (let i = 0; i < forms.length; i++) {
    const temp_id = "CUS-" + Math.floor(Math.random() * 1e10);
    temp_id_list.push(temp_id);
    forms[i].tempId = temp_id;
    const formData = new FormData();

    // Add the pet image file if it exists
    if (forms[i].photo && forms[i].photo instanceof File) {
      formData.append("pet_img", forms[i].photo);
    }

    // Add the discount proof file if it exists
    if (forms[i].discountProof && forms[i].discountProof instanceof File) {
      formData.append("discount_proof", forms[i].discountProof);
    }

    // Prepare the data object
    const data = {
      lastName: forms[i].lastName,
      phoneNumber: forms[i].phoneNumber,
      address: forms[i].address || forms[i].shippingAddress,
      email: forms[i].email,
      option: forms[i].option,
      type: forms[i].version === "custom" ? "cust" : "nor",
      tempId: temp_id,
      paymentWay: forms[i].paymentWay,
      delivery: forms[i].delivery,
      price: forms[i].price,
      shopCode: forms[i].coupon || "",
      promotionCode: forms[i].coupon || "",
      // Only for custom
      petContact: forms[i].version === "custom" ? forms[i].petContact : undefined,
      petName: forms[i].petName,
      optionSize: forms[i].size,
      optionColor: forms[i].color,
      lang: language === "zh" ? "chn" : language,
    };

    // Remove undefined fields
    Object.keys(data).forEach((k) => data[k] === undefined && delete data[k]);

    // Add all form fields to FormData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    try {
      const response = await axios.post(
        `${API_BASE_URL}/purchase/confirmation`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
    } catch (error) {
      console.error(error);
    }
  }

  try {
    const dataforSFExpress = {
      lastName: forms[0].lastName,
      phoneNumber: forms[0].phoneNumber,
      address: forms[0].address || forms[0].shippingAddress,
      attrName: forms[0].attrName,
      netCode: forms[0].netCode,
      serviceName: forms[0].serviceName,
      tempIdList: temp_id_list,
      count: forms.length,
    };

    const responseSFExpress = await axios.post(
      `${API_BASE_URL}/sf-express-routes/create-order`,
      dataforSFExpress,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const waybillNo = responseSFExpress.data.trackingNumber;

    const dataForWayBill = {
      waybillNo: waybillNo,
    };

    await axios.post(
      `${API_BASE_URL}/sf-express-routes/print-cloud-waybill`,
      dataForWayBill,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return { responseSFExpress };
  } catch (error) {
    console.error(error);
  }
}

